(() => {
  const CONFIG_SELECTOR = '[data-eg-digital-config]';
  const PRODUCT_SELECTOR = '[data-eg-digital-product-module]';
  const CART_SELECTOR = '[data-eg-digital-cart-module]';
  const CART_ICON_SELECTOR = '#cart-icon-bubble';
  const CART_PAGE_SELECTOR = '#main-cart-items';
  const CART_DRAWER_SELECTOR = '#CartDrawer';
  const ATTRIBUTE_CHANNEL = 'Entrega digital - canal';
  const ATTRIBUTE_CONTACT = 'Entrega digital - contacto';
  let cartRequest = null;
  let cartEventsBound = false;
  let attributeQueue = Promise.resolve();
  const preferenceTimers = new WeakMap();

  const readConfig = () => {
    const node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  };

  const setText = (root, field, value) => {
    if (value === undefined || value === null || value === '') return;
    root.querySelectorAll(`[data-eg-digital-field="${field}"]`).forEach((node) => { node.textContent = value; });
  };

  const enabledChannelOptions = (config) => [
    { key: 'whatsapp', enabled: config.showWhatsapp, label: config.whatsappLabel, placeholder: config.whatsappPlaceholder, inputMode: 'tel', autocomplete: 'tel' },
    { key: 'facebook', enabled: config.showFacebook, label: config.facebookLabel, placeholder: config.facebookPlaceholder, inputMode: 'text', autocomplete: 'off' },
    { key: 'email', enabled: config.showEmail, label: config.emailLabel, placeholder: config.emailPlaceholder, inputMode: 'email', autocomplete: 'email' },
    { key: 'instagram', enabled: config.showInstagram, label: config.instagramLabel, placeholder: config.instagramPlaceholder, inputMode: 'text', autocomplete: 'off' }
  ].filter((option) => option.enabled && option.label);

  const enabledChannels = (config) => enabledChannelOptions(config).map((option) => option.label);

  const formatChannels = (config) => {
    const channels = enabledChannels(config);
    if (channels.length === 0) return '';
    if (channels.length === 1) return channels[0];
    if (channels.length === 2) return `${channels[0]} o ${channels[1]}`;
    return `${channels.slice(0, -1).join(', ')} o ${channels[channels.length - 1]}`;
  };

  const syncChannels = (root, config) => {
    const states = [
      ['whatsapp', config.showWhatsapp, 'whatsappLabel', config.whatsappLabel],
      ['facebook', config.showFacebook, 'facebookLabel', config.facebookLabel],
      ['email', config.showEmail, 'emailLabel', config.emailLabel],
      ['instagram', config.showInstagram, 'instagramLabel', config.instagramLabel]
    ];
    states.forEach(([key, visible, field, label]) => {
      root.querySelectorAll(`[data-eg-digital-channel="${key}"]`).forEach((node) => { node.hidden = !visible; });
      setText(root, field, label);
    });
    const enabled = states.filter((state) => state[1]).map((state) => state[0]);
    root.querySelectorAll('[data-eg-digital-separator="whatsapp"]').forEach((node) => { node.hidden = !(enabled.includes('whatsapp') && enabled.length > 1); });
    root.querySelectorAll('[data-eg-digital-separator="facebook"]').forEach((node) => { node.hidden = !(enabled.includes('facebook') && enabled.length > 2); });
    root.querySelectorAll('[data-eg-digital-separator="email"]').forEach((node) => { node.hidden = !(enabled.includes('email') && enabled.includes('instagram')); });
  };

  const applyProductModules = (config) => {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach((module) => {
      if (config && config.enabled === false) {
        module.hidden = true;
        module.closest('product-info')?.classList.remove('eg-has-digital-product');
        return;
      }
      module.hidden = false;
      module.closest('product-info')?.classList.add('eg-has-digital-product');
      if (!config) return;
      setText(module, 'pdpBadgeText', config.pdpBadgeText);
      if (module.dataset.egDigitalAvailable === 'true') setText(module, 'availabilityText', config.availabilityText);
      setText(module, 'eyebrow', config.eyebrow);
      setText(module, 'title', config.title);
      setText(module, 'deliveryTime', config.deliveryTime);
      setText(module, 'deliverySuffix', config.deliverySuffix);
      setText(module, 'channelsLead', config.channelsLead);
      setText(module, 'paymentText', config.paymentText);
      setText(module, 'noShippingText', config.noShippingText);
      syncChannels(module, config);
    });
  };

  const cartRoot = () => window.Shopify?.routes?.root || '/';

  const fetchCart = () => {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(`${cartRoot()}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .finally(() => { cartRequest = null; });
    return cartRequest;
  };

  const updateCartAttributes = (attributes) => {
    attributeQueue = attributeQueue
      .catch(() => {})
      .then(() => fetch(`${cartRoot()}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes })
      }))
      .then((response) => {
        if (!response.ok) throw new Error('Cart attribute update failed');
        return response.json();
      });
    return attributeQueue;
  };

  const classifyCart = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const digitalItems = items.filter((item) => item.requires_shipping === false);
    const physicalItems = items.filter((item) => item.requires_shipping !== false);
    if (digitalItems.length === 0) return { mode: 'physical', digitalItems, physicalItems };
    if (physicalItems.length === 0) return { mode: 'digital', digitalItems, physicalItems };
    return { mode: 'mixed', digitalItems, physicalItems };
  };

  const cartTargets = () => {
    const targets = [];
    const page = document.querySelector('#main-cart-items .js-contents');
    const drawer = document.querySelector('#CartDrawer-CartItems');
    if (page) targets.push({ root: page, surface: 'page' });
    if (drawer) targets.push({ root: drawer, surface: 'drawer' });
    return targets;
  };

  const removeCartModules = () => {
    document.querySelectorAll(CART_SELECTOR).forEach((node) => node.remove());
  };

  const clearStaleDigitalAttributes = (cart) => {
    const attributes = cart?.attributes || {};
    if (!attributes[ATTRIBUTE_CHANNEL] && !attributes[ATTRIBUTE_CONTACT]) return;
    updateCartAttributes({
      [ATTRIBUTE_CHANNEL]: '',
      [ATTRIBUTE_CONTACT]: ''
    }).catch(() => {});
  };

  const makeIcon = (symbol) => {
    const icon = document.createElement('span');
    icon.className = 'eg-digital-cart__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = symbol;
    return icon;
  };

  const makeDeliveryCard = (label, text, symbol, modifier = '') => {
    const card = document.createElement('div');
    card.className = `eg-digital-cart__delivery${modifier ? ` eg-digital-cart__delivery--${modifier}` : ''}`;
    card.appendChild(makeIcon(symbol));
    const copy = document.createElement('div');
    const strong = document.createElement('strong');
    strong.textContent = label;
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    copy.append(strong, paragraph);
    card.appendChild(copy);
    return card;
  };

  const selectedChannelOption = (form, config) => {
    const checked = form.querySelector('input[data-eg-digital-channel-option]:checked');
    if (!checked) return null;
    return enabledChannelOptions(config).find((option) => option.label === checked.value) || null;
  };

  const configureContactInput = (input, option, config) => {
    if (!input) return;
    input.disabled = !option;
    input.placeholder = option?.placeholder || config.contactPlaceholder || '';
    input.inputMode = option?.inputMode || 'text';
    input.autocomplete = option?.autocomplete || 'off';
    input.type = option?.key === 'email' ? 'email' : option?.key === 'whatsapp' ? 'tel' : 'text';
  };

  const setPreferenceStatus = (form, text, state = '') => {
    const status = form.querySelector('[data-eg-digital-preference-status]');
    if (!status) return;
    status.textContent = text || '';
    status.dataset.state = state;
  };

  const syncPreferenceUI = (channel, contact, config, sourceForm = null) => {
    document.querySelectorAll('[data-eg-digital-preference]').forEach((form) => {
      if (form === sourceForm) return;
      form.querySelectorAll('input[data-eg-digital-channel-option]').forEach((radio) => {
        radio.checked = radio.value === channel;
      });
      const input = form.querySelector('[data-eg-digital-contact]');
      if (input) input.value = contact || '';
      form.dataset.egDigitalLastChannel = channel || '';
      configureContactInput(input, selectedChannelOption(form, config), config);
    });
  };

  const persistPreference = (form, config) => {
    const option = selectedChannelOption(form, config);
    if (!option) return Promise.resolve();
    const input = form.querySelector('[data-eg-digital-contact]');
    const contact = String(input?.value || '').trim().slice(0, 160);
    setPreferenceStatus(form, config.savingText, 'saving');
    return updateCartAttributes({
      [ATTRIBUTE_CHANNEL]: option.label,
      [ATTRIBUTE_CONTACT]: contact
    })
      .then(() => {
        setPreferenceStatus(form, config.savedText, 'saved');
        syncPreferenceUI(option.label, contact, config, form);
      })
      .catch(() => setPreferenceStatus(form, config.saveErrorText, 'error'));
  };

  const schedulePreferenceSave = (form, config, delay = 650) => {
    const previous = preferenceTimers.get(form);
    if (previous) window.clearTimeout(previous);
    const timer = window.setTimeout(() => {
      preferenceTimers.delete(form);
      persistPreference(form, config);
    }, delay);
    preferenceTimers.set(form, timer);
  };

  const makePreferenceForm = (cart, config, surface) => {
    if (config.showDeliveryPreference === false) return null;
    const options = enabledChannelOptions(config);
    if (options.length === 0) return null;

    const attributes = cart?.attributes || {};
    const currentChannel = String(attributes[ATTRIBUTE_CHANNEL] || '');
    const currentContact = String(attributes[ATTRIBUTE_CONTACT] || '');

    const form = document.createElement('div');
    form.className = 'eg-digital-cart__preference';
    form.dataset.egDigitalPreference = '';
    form.dataset.egDigitalLastChannel = currentChannel;

    const headingRow = document.createElement('div');
    headingRow.className = 'eg-digital-cart__preference-head';
    const title = document.createElement('strong');
    title.textContent = config.preferenceTitle;
    headingRow.appendChild(title);
    if (config.preferenceOptionalText) {
      const optional = document.createElement('span');
      optional.textContent = config.preferenceOptionalText;
      headingRow.appendChild(optional);
    }
    form.appendChild(headingRow);

    if (config.preferenceHelp) {
      const help = document.createElement('p');
      help.className = 'eg-digital-cart__preference-help';
      help.textContent = config.preferenceHelp;
      form.appendChild(help);
    }

    const choiceGroup = document.createElement('div');
    choiceGroup.className = 'eg-digital-cart__channel-options';
    choiceGroup.setAttribute('role', 'radiogroup');
    choiceGroup.setAttribute('aria-label', config.preferenceTitle);
    const groupName = `eg-digital-channel-${surface}-${Math.random().toString(36).slice(2, 8)}`;

    options.forEach((option) => {
      const label = document.createElement('label');
      label.className = 'eg-digital-cart__channel-option';
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = groupName;
      radio.value = option.label;
      radio.dataset.egDigitalChannelOption = option.key;
      radio.checked = currentChannel === option.label;
      const visual = document.createElement('span');
      visual.textContent = option.label;
      label.append(radio, visual);
      choiceGroup.appendChild(label);
    });
    form.appendChild(choiceGroup);

    const contactWrap = document.createElement('label');
    contactWrap.className = 'eg-digital-cart__contact';
    const contactLabel = document.createElement('span');
    contactLabel.textContent = config.contactLabel;
    const input = document.createElement('input');
    input.dataset.egDigitalContact = '';
    input.value = currentContact;
    input.maxLength = 160;
    input.spellcheck = false;
    contactWrap.append(contactLabel, input);
    form.appendChild(contactWrap);

    const status = document.createElement('span');
    status.className = 'eg-digital-cart__preference-status';
    status.dataset.egDigitalPreferenceStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.appendChild(status);

    configureContactInput(input, selectedChannelOption(form, config), config);

    choiceGroup.addEventListener('change', () => {
      const option = selectedChannelOption(form, config);
      const previousChannel = form.dataset.egDigitalLastChannel || '';
      if (option && previousChannel && previousChannel !== option.label) input.value = '';
      form.dataset.egDigitalLastChannel = option?.label || '';
      configureContactInput(input, option, config);
      persistPreference(form, config);
    });

    input.addEventListener('input', () => {
      if (!selectedChannelOption(form, config)) return;
      schedulePreferenceSave(form, config);
    });

    input.addEventListener('blur', () => {
      const timer = preferenceTimers.get(form);
      if (!timer || !selectedChannelOption(form, config)) return;
      window.clearTimeout(timer);
      preferenceTimers.delete(form);
      persistPreference(form, config);
    });

    return form;
  };

  const makeCartModule = (cart, mode, surface, config, signature) => {
    const module = document.createElement('section');
    module.className = `eg-digital-cart eg-digital-cart--${mode} eg-digital-cart--${surface}`;
    module.dataset.egDigitalCartModule = '';
    module.dataset.egDigitalCartMode = mode;
    module.dataset.egDigitalCartSignature = signature;
    module.setAttribute('aria-label', mode === 'digital' ? 'Información de compra digital' : 'Información de tipos de entrega');

    const head = document.createElement('div');
    head.className = 'eg-digital-cart__head';
    const badge = document.createElement('span');
    badge.className = 'eg-digital-cart__badge';
    badge.textContent = `⚡ ${mode === 'digital' ? config.digitalCartBadge : config.mixedCartBadge}`;
    const title = document.createElement('strong');
    title.className = 'eg-digital-cart__title';
    title.textContent = mode === 'digital' ? config.digitalCartTitle : config.mixedCartTitle;
    head.append(badge, title);
    module.appendChild(head);

    const content = document.createElement('div');
    content.className = 'eg-digital-cart__content';

    if (mode === 'digital') {
      const deliveryText = `${config.deliveryTime} ${config.deliverySuffix}`.trim();
      content.appendChild(makeDeliveryCard(config.digitalDeliveryLabel, deliveryText, '⚡', 'digital'));
      const channels = formatChannels(config);
      if (channels) {
        const channelLine = document.createElement('p');
        channelLine.className = 'eg-digital-cart__line';
        channelLine.appendChild(makeIcon('↗'));
        const span = document.createElement('span');
        span.textContent = `${config.channelsLead} ${channels}.`;
        channelLine.appendChild(span);
        content.appendChild(channelLine);
      }
      const shippingLine = document.createElement('p');
      shippingLine.className = 'eg-digital-cart__line eg-digital-cart__line--strong';
      shippingLine.appendChild(makeIcon('✓'));
      const shippingText = document.createElement('span');
      shippingText.textContent = config.noShippingText;
      shippingLine.appendChild(shippingText);
      content.appendChild(shippingLine);
    } else {
      const body = document.createElement('p');
      body.className = 'eg-digital-cart__body';
      body.textContent = config.mixedCartBody;
      content.appendChild(body);

      const grid = document.createElement('div');
      grid.className = 'eg-digital-cart__delivery-grid';
      grid.appendChild(makeDeliveryCard(config.digitalDeliveryLabel, `${config.deliveryTime} ${config.deliverySuffix}`.trim(), '⚡', 'digital'));
      grid.appendChild(makeDeliveryCard(config.physicalDeliveryLabel, config.physicalDeliveryText, '▣', 'physical'));
      content.appendChild(grid);

      if (config.mixedReassurance) {
        const reassurance = document.createElement('p');
        reassurance.className = 'eg-digital-cart__reassurance';
        reassurance.appendChild(makeIcon('✓'));
        const text = document.createElement('strong');
        text.textContent = config.mixedReassurance;
        reassurance.appendChild(text);
        content.appendChild(reassurance);
      }
      if (config.showSplitNote !== false && config.splitNote) {
        const split = document.createElement('p');
        split.className = 'eg-digital-cart__split';
        split.textContent = config.splitNote;
        content.appendChild(split);
      }
    }

    const preference = makePreferenceForm(cart, config, surface);
    if (preference) content.appendChild(preference);

    module.appendChild(content);
    return module;
  };

  const renderCart = (cart, config) => {
    const { mode, digitalItems, physicalItems } = classifyCart(cart);
    if (!config || config.enabled === false || config.showCartSummary === false || mode === 'physical') {
      removeCartModules();
      if (mode === 'physical') clearStaleDigitalAttributes(cart);
      return;
    }

    const attributes = cart?.attributes || {};
    const signature = [
      mode,
      digitalItems.map((item) => `${item.key}:${item.quantity}`).join('|'),
      physicalItems.map((item) => `${item.key}:${item.quantity}`).join('|'),
      attributes[ATTRIBUTE_CHANNEL] || '',
      attributes[ATTRIBUTE_CONTACT] || ''
    ].join('::');

    cartTargets().forEach(({ root, surface }) => {
      const existing = root.querySelector(`:scope > ${CART_SELECTOR}`);
      if (existing?.dataset.egDigitalCartSignature === signature && existing.dataset.egDigitalCartMode === mode) return;
      existing?.remove();
      const module = makeCartModule(cart, mode, surface, config, signature);
      root.prepend(module);
    });
  };

  const refreshCart = () => {
    const config = readConfig();
    if (!config || config.enabled === false || config.showCartSummary === false) {
      removeCartModules();
      return Promise.resolve();
    }
    return fetchCart()
      .then((cart) => renderCart(cart, config))
      .catch(() => {});
  };

  const bindCartEvents = () => {
    if (cartEventsBound) return;
    cartEventsBound = true;

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest(CART_ICON_SELECTOR)) window.setTimeout(refreshCart, 0);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(refreshCart, 0));
    }
  };

  const apply = () => {
    const config = readConfig();
    applyProductModules(config);
    bindCartEvents();
    if (document.querySelector(CART_PAGE_SELECTOR)) refreshCart();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();

  document.addEventListener('shopify:section:load', () => {
    apply();
    if (document.querySelector(`${CART_PAGE_SELECTOR}, ${CART_DRAWER_SELECTOR}`)) window.setTimeout(refreshCart, 0);
  });
})();
